import Subject from "../cse4sub/Subject";
import React from 'react'
import csem from '../assets/CSEASH301Cmid21.pdf'
import csee from '../assets/CSEASH301Cend21.pdf'

export default function M_3() {
  return (
    <div>
       <Subject title="Mathematics-3(ASH301C)"mid="Q. Paper"
    book1="G.B. Thomas and R.L. Finney, Calculus and Analytic geometry, 9thEdition, Pearson, Reprint " 
    book2="Reprint, 2002.Erwin Kreyszig, Advanced Engineering Mathematics, 9thEdition, John Wiley & Sons "
    book1Link="http://www.sufwan.com/wp-content/uploads/CalculusAndAnalyticalGeometry/Calculus-Book-Thomas-Finney.pdf
    " 
    book2Link="https://physicaeducator.files.wordpress.com/2017/11/erwin_kreyszig-_advanced_engineering_mathematics.pdf
    " 
    int21="#" mid21={csem} end21={csee}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}